// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.schmenu_layer .munu_list li a:hover { background:#F2F9FE; color: #000 !important; cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
